import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useAuth0 } from "../auth/react-auth0-wrapper";
/**
 * Copies all sessionStorage items to cookies for cross-subdomain access.
 */
var copySessionStorageToCookies = function copySessionStorageToCookies() {
  var sessionKeys = Object.keys(sessionStorage);
  sessionKeys.forEach(function (key) {
    var value = sessionStorage.getItem(key);
    if (value) {
      var encodedValue = encodeURIComponent(value);
      document.cookie = "".concat(key, "=").concat(encodedValue, "; domain=.baylorgenetics.com; path=/; secure; samesite=none;");
    }
  });
};
/**
 * Builds the V2 redirect URL by:
 * 1. Replacing path params (e.g., :id) with actual values from current URL
 * 2. Transforming query params (test -> testcode)
 * 3. Removing V1-specific params
 */
var buildV2RedirectUrl = function buildV2RedirectUrl(v2BaseUrl, v2Path, currentPath, v1PathPattern) {
  var finalV2Path = v2Path;
  // Handle dynamic path params - extract values from V1 path and replace in V2 path
  if (v1PathPattern && v1PathPattern.includes(":")) {
    var v1Parts = v1PathPattern.split("/");
    var currentParts = currentPath.split("/");
    // Collect all param values from V1 path in order
    var paramValues = [];
    v1Parts.forEach(function (part, index) {
      if (part.startsWith(":")) {
        var paramValue = currentParts[index];
        if (paramValue) {
          paramValues.push(paramValue);
        }
      }
    });
    // Replace all :paramName patterns in V2 path with collected values (in order)
    var paramIndex = 0;
    finalV2Path = finalV2Path.replace(/:[a-zA-Z_]+/g, function () {
      var value = paramValues[paramIndex] || "";
      paramIndex++;
      return value;
    });
  }
  // Build query string manually to avoid URLSearchParams encoding/normalization.
  // We need two special transformations:
  //   1. remove any "new-cart" parameter entirely
  //   2. rename every occurrence of "test=" to "testcode=", even when multiple
  //      test values are comma‑separated in a single parameter.
  var queryString = window.location.search && window.location.search.startsWith("?") ? window.location.search.substring(1) : window.location.search || "";
  // strip out new-cart param (value may or may not be present), keep surrounding separators
  queryString = queryString.replace(/(^|&)new-cart(?:=[^&]*)?(?=&|$)/g, "");
  // trim stray ampersands that may accumulate
  queryString = queryString.replace(/(^&+|&+$)/g, "");
  // rename all test= occurrences; include those preceded by comma as well as start/&
  queryString = queryString.replace(/(^|[&,])test=/g, "$1testcode=");
  return "".concat(v2BaseUrl).concat(finalV2Path).concat(queryString ? "?".concat(queryString) : "");
};
/**
 * A route component that conditionally redirects to V2 portal based on feature flag.
 * If redirect is enabled (isV2Ui = true), navigates to the V2 portal URL.
 * Otherwise, renders the V1 component as a private route.
 */
var V2RedirectRoute = function V2RedirectRoute(_a) {
  var component = _a.component,
    path = _a.path,
    v2Path = _a.v2Path,
    enableRedirect = _a.enableRedirect,
    rest = __rest(_a, ["component", "path", "v2Path", "enableRedirect"]);
  var _useAuth = useAuth0(),
    loading = _useAuth.loading,
    isAuthenticated = _useAuth.isAuthenticated,
    loginWithRedirect = _useAuth.loginWithRedirect; // Handle unauthenticated users - redirect to login, unless a logout just happened
  useEffect(function () {
    if (loading || isAuthenticated) {
      return;
    }
    // After logout from V1 or V2, a cross-subdomain cookie is set so we can
    // detect it here and skip auto-login. Without this, loginWithRedirect fires
    // immediately, the IdP silently re-authenticates, and the user ends up back
    // on the V2 dashboard — making logout appear broken.
    if (document.cookie.includes("logout_initiated=1")) {
      document.cookie = "logout_initiated=; domain=.baylorgenetics.com; path=/; max-age=0";
    }
    var fn = function fn() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = loginWithRedirect;
                if (!_context.t0) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return loginWithRedirect({
                  appState: {
                    targetUrl: window.location.href
                  }
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);
  // Handle V2 redirect when enabled
  useEffect(function () {
    if (isAuthenticated && enableRedirect) {
      var v2BaseUrl = window.appConfig.v2FEUrl;
      if (v2BaseUrl) {
        // Copy sessionStorage to cookies for V2 to access
        copySessionStorageToCookies();
        // Build and navigate to V2 URL
        var redirectUrl = buildV2RedirectUrl(v2BaseUrl, v2Path, window.location.pathname, path);
        window.location.href = redirectUrl;
      }
    }
  }, [isAuthenticated, enableRedirect, v2Path, path]);
  // Show nothing while redirecting
  if (enableRedirect && isAuthenticated) {
    return null;
  }
  // Render V1 component if authenticated and not redirecting
  if (isAuthenticated) {
    return React.createElement(Route, Object.assign({
      path: path,
      component: component
    }, rest));
  }
  return null;
};
export default V2RedirectRoute;